
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.VisualStudio.Services.Common
//----------------------------------------------------------


export module ArtifactTypeNames {
    export var TcmResult = "TcmResult";
    export var TcmResultAttachment = "TcmResultAttachment";
    export var TcmTest = "TcmTest";
    export var Build = "Build";
    export var VersionedItem = "VersionedItem";
    export var LatestItemVersion = "LatestItemVersion";
    export var Changeset = "Changeset";
    export var Shelveset = "Shelveset";
    export var WorkItem = "WorkItem";
    export var Storyboard = "Storyboard";
    export var Commit = "Commit";
    export var CodeReviewId = "CodeReviewId";
    export var CodeReviewSdkId = "ReviewId";
    export var PullRequestId = "PullRequestId";
    export var ProjectDownloadProject = "Project";
    /**
    * A Git Ref
    */
    export var Ref = "Ref";
    export var WikiPage = "WikiPage";
    export var PullRequest = "PullRequest";
    export var Issue = "Issue";
}

export module ToolNames {
    export var VersionControl = "VersionControl";
    export var WorkItemTracking = "WorkItemTracking";
    export var RemoteWorkItemTracking = "RemoteWorkItemTracking";
    export var TeamBuild = "Build";
    export var TestManagement = "TestManagement";
    export var Requirements = "Requirements";
    export var Hyperlink = "Hyperlink";
    export var Legacy = "Legacy";
    export var CodeSense = "CodeSense";
    export var Git = "Git";
    export var CodeReview = "CodeReview";
    export var ProjectDownload = "ProjectDownload";
    export var Wiki = "Wiki";
    export var GitHub = "GitHub";
}

